/**
 * 监控API
 * Feature: vanadium-industry-map
 * 验证需求：11.5
 */
import { apiClient } from './client';

export interface DataSourceStatus {
  source: string;
  last_collected: string | null;
  total_records: number;
  coverage: Record<string, number>;
  health_status: 'healthy' | 'warning' | 'critical' | 'unknown';
  expected_update_frequency: string;
}

export interface DataSourcesResponse {
  price_data: DataSourceStatus;
  storage_projects: DataSourceStatus;
  production_data: DataSourceStatus;
  overall_status: string;
}

export interface QualityReport {
  id: number;
  data_type: string;
  check_time: string;
  total_records: number;
  valid_records: number;
  invalid_records: number;
  completeness_score: number;
  accuracy_score: number;
  quality_score: number;
  issues: string[];
  recommendations: string[];
}

export interface QualityReportsResponse {
  total: number;
  skip: number;
  limit: number;
  reports: QualityReport[];
}

export interface QualitySummaryResponse {
  period: {
    start_date: string;
    end_date: string;
    days: number;
  };
  overall: {
    average_score: number;
    status: 'good' | 'warning' | 'critical';
  };
  by_data_type: Array<{
    data_type: string;
    average_score: number;
    min_score: number;
    max_score: number;
    report_count: number;
  }>;
  recent_issues: Array<{
    data_type: string;
    check_time: string;
    quality_score: number;
    issues: string[];
  }>;
}

export interface SystemHealthResponse {
  timestamp: string;
  overall_health: 'healthy' | 'warning' | 'critical' | 'unknown';
  database: {
    status: string;
  };
  data_sources: DataSourcesResponse;
  recommendations: string[];
}

/**
 * 获取数据源健康状态
 */
export const getDataSourcesStatus = async (): Promise<DataSourcesResponse> => {
  return apiClient.get('/monitoring/data-sources');
};

/**
 * 获取数据质量报告
 */
export const getQualityReports = async (params?: {
  start_date?: string;
  end_date?: string;
  data_type?: string;
  min_score?: number;
  skip?: number;
  limit?: number;
}): Promise<QualityReportsResponse> => {
  return apiClient.get('/monitoring/quality-reports', { params });
};

/**
 * 获取数据质量汇总统计
 */
export const getQualitySummary = async (days: number = 7): Promise<QualitySummaryResponse> => {
  return apiClient.get('/monitoring/quality-summary', { params: { days } });
};

/**
 * 获取系统整体健康状态
 */
export const getSystemHealth = async (): Promise<SystemHealthResponse> => {
  return apiClient.get('/monitoring/system-health');
};
